import React, { createContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useUser } from '../context/UserContext';
import { Snackbar, Alert } from "@mui/material";

const TimerContext = createContext();

export const TimerProvider = ({ children }) => {
  const { handleLogout, accessToken } = useAuth(); // Logout function from AuthContext
    const {user, updateUser} = useUser();  
  const { ttl } = useUser(); // Get the ttl from UserContext
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const [showAlert, setShowAlert] = useState(false);

  const startHandleLogout = () => {
    console.log("Timer ttl", user.ttl); // Debugging log

    if (!accessToken || user.ttl === 0) {
      // If accessToken is null or empty, do not proceed with logout or show alert
      return;
    }

    setShowAlert(true); // Show alert before logging out
    setTimeout(() => {
      handleLogout(); // Log out the user
      navigate("/"); // Redirect to login page
    }, 5000); // Wait 3 seconds before redirect
    //setShowAlert(true); // Show alert before logging out

  };

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      //handleLogout(); // Log out the user
      startHandleLogout(); // Start the logout process
      //navigate('/'); // Redirect to the login screen
    }, user.ttl * 1000); // Set the timeout to the ttl value from UserContext
  };

  useEffect(() => {
    // Set up the initial timer
    resetTimer();

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [accessToken]); // Reset timer when accessToken changes
     
  return <TimerContext.Provider value={{}}>{children}
  <Snackbar open={showAlert} autoHideDuration={5000}
      onClose={() => setShowAlert(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity="warning" variant="filled">
          <b>Session expired after 30 minutes! Redirecting to login...Please Login again.</b>
        </Alert>
      </Snackbar>
  </TimerContext.Provider>;
};


export default TimerContext;